'use es6';

import { useState } from 'react';
import { useInterval } from 'ContentComponents/cmv2/hooks/useInterval';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDuration from 'I18n/components/FormattedDuration';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
const ONE_MINUTE = 60000;
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.saveIndicator.${key}`;
const SavedMessage = ({
  updatedAt
}) => /*#__PURE__*/_jsx(UITooltip, {
  title: /*#__PURE__*/_jsx(LastSavedMessage, {
    updatedAt: updatedAt
  }),
  tooltipPlacement: "bottom",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    "data-selenium": "form-save-indicator-saved",
    message: i18nKey('saved')
  })
});
const SavingMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: i18nKey('saving')
});
const RetryLink = ({
  onClick
}) => /*#__PURE__*/_jsx(UILink, {
  use: "transparent",
  onClick: onClick,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('failed.retry')
  })
});
const ReloadLink = ({
  onClick
}) => /*#__PURE__*/_jsx(UILink, {
  use: "transparent",
  onClick: onClick,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('preconditionFailed.retry')
  })
});
const FailedMessage = ({
  tooltipLabel,
  action
}) => /*#__PURE__*/_jsx(UITooltip, {
  title: tooltipLabel,
  tooltipPlacement: "bottom",
  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: i18nKey('failed.message'),
    options: {
      link: action
    }
  })
});
const LastSavedMessage = ({
  updatedAt
}) => /*#__PURE__*/_jsx(FormattedReactMessage, {
  message: i18nKey('sinceSave'),
  options: {
    duration: /*#__PURE__*/_jsx(FormattedDuration, {
      to: updatedAt,
      includeAffix: true
    })
  }
});
const SavedIndicator = ({
  label,
  isSaving,
  isFailed
}) => /*#__PURE__*/_jsx(UILoadingSpinner, {
  className: "m-all-0",
  use: "tertiary",
  size: "extra-small",
  layout: "inline",
  showLabel: true,
  showResult: !isSaving,
  failed: isFailed,
  label: label,
  labelCompletedText: label
});
const FormSaveIndicator = ({
  isSaving,
  isPreConditionFailed,
  isFailed,
  onRetry,
  onReload,
  updatedAt
}) => {
  const [__, setTick] = useState(0);
  useInterval(() => {
    setTick(previousTick => previousTick + 1);
  }, ONE_MINUTE);
  let label = /*#__PURE__*/_jsx(SavedMessage, {
    updatedAt: updatedAt
  });
  if (isSaving) {
    label = /*#__PURE__*/_jsx(SavingMessage, {});
  } else if (isPreConditionFailed) {
    label = /*#__PURE__*/_jsx(FailedMessage, {
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('preconditionFailed.message')
      }),
      action: /*#__PURE__*/_jsx(ReloadLink, {
        onClick: onReload
      })
    });
  } else if (isFailed) {
    label = /*#__PURE__*/_jsx(FailedMessage, {
      tooltipLabel: "",
      action: /*#__PURE__*/_jsx(RetryLink, {
        onClick: onRetry
      })
    });
  }
  return /*#__PURE__*/_jsx(SavedIndicator, {
    isSaving: isSaving,
    isFailed: isPreConditionFailed || isFailed,
    updatedAt: updatedAt,
    label: label
  });
};
export default FormSaveIndicator;